import '../public/global.css';
import App from './App.svelte';

// Keplr and Leap wallet connection logic
async function connectWallets() {
    const chainId = 'stargaze-1'; 
    let walletAddress = '';

    // Keplr Wallet
if (window.keplr) {
    try {
        await window.keplr.enable(chainId);
        const offlineSigner = window.getOfflineSigner(chainId);
        const accounts = await offlineSigner.getAccounts();
        walletAddress = accounts[0].address;
        console.log('Keplr wallet connected:', walletAddress);
    } catch (error) {
        console.error('Error connecting Keplr wallet:', error.message);
        console.error('Error details:', error);
    }
} else {
    console.error('Keplr wallet not found');
}

    // Leap Wallet
    if (window.leap) {
        try {
            await window.leap.enable(chainId);
            const offlineSigner = window.getOfflineSigner(chainId);
            const accounts = await offlineSigner.getAccounts();
            walletAddress = accounts[0].address;
            console.log('Leap wallet connected:', walletAddress);
        } catch (error) {
            console.error('Error connecting Leap wallet:', error);
        }
    }

    return walletAddress;
}

connectWallets().then(walletAddress => {
    const app = new App({
        target: document.body,
        props: {
            walletAddress
        }
    });
}).catch(error => {
    console.error('Error initializing app:', error);
});

export default app;